export default [
  {
    path: '/',
    redirect: '/bootpage'
  },
  {
    path: '/ldh/ent/:url',
    component: () => import('../views/login/login/PrevCheck.vue'),
    meta: {
      norequirelogin: true
    }
  },
  {
    path: 'productplatform',
    name: 'productplatform',
    component: () => import('@/views/product/platform/Platform.vue'),
    children: [
      { //首页
        path: '/bootpage',
        name: 'HomePageList',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '首页',},
        component: () => import('@/views/product/boot/HomePageList.vue'),
      },
      { //商品菜单
        path: '/productpagelist',
        name: 'ProductPageList',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '商品菜单',},
        component: () => import('@/views/product/boot/ProductPageList.vue'),
      },
      { //访客
        path: '/visitor',
        name: 'Visitor',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '访客列表',},
        component: () => import('@/views/basesettings/Visitor'),
      },
      { //咨询
        path: '/consult_list',
        name: 'ConsultList',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '咨询列表',},
        component: () => import('@/views/basesettings/ConsultList'),
      },
      { //答案
        path: '/answerlist',
        name: 'answerlist',
        meta: {
          title: '咨询记录'
        },
        component: () => import('@/views/basesettings/AnswerList'),
      },
      { //商品列表
        path: '/productlist',
        name: 'ProductList',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '商品列表'},
        component: () => import('@/views/product/productlist/ProductList.vue')
      },
      { //商品菜单
        path: '/productpage',
        name: 'ProductPage',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '商品列表'},
        component: () => import('@/views/product/productlist/ProductPage')
      },
      { //装修商品
        path: '/goodsdetail',
        name: 'goodsdetail',
        component: () => import('../views/product/productlist/GoodsDetail.vue'),
        'meta': {'hideInMenu': true, 'title': '装修商品'},
      },
      { //商品案例
        path: '/goodscase',
        name: 'goodscase',
        component: () => import('../views/product/productlist/GoodsCase.vue'),
        'meta': {'hideInMenu': true, 'title': '商品案例'},
      },
      { //落地页
        path: '/materialbasepage',
        name: 'MaterialBasePage',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '落地页',},
        component: () => import('@/views/material/basepage/MaterialBasePage'),
      },
      { //引导页
        path: '/guidepage',
        name: 'GuidePage',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '引导页',},
        component: () => import('@/views/material/guidepage/GuidePage'),
      },
      { //视频库
        path: '/videorepository',
        name: 'VideoRepository',
        'params': {}, 'query': {}, 'meta': {hideInMenu: true, title: '视频库', hideInBread: true},
        component: () => import('@/views/material/video/VideoRepository'),
      },
      { //新增视频
        path: '/videoUpload',
        name: 'VideoUpload',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '上传视频',},
        component: () => import('@/views/material/video/VideoUpload'),
      },
      { //视频编辑
        path: '/editVideo',
        name: 'EditVideo',
        'params': {}, 'query': {}, 'meta': {hideInMenu: true, title: '视频编辑', hideInBread: true},
        component: () => import('@/views/material/video/EditVideo'),
      },
      { //图片库
        path: '/picturerepository',
        name: 'PictureRepository2',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '图片库',},
        component: () => import('@/views/material/picture/PictureRepository2'),
      },
      { //新增图片
        path: '/uploadpic',
        name: 'UploadPic',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '新增图片',},
        component: () => import('@/views/material/picture/UploadPic'),
      },
      { //编辑图片
        path: '/editpic',
        name: 'editpic',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '编辑图片',},
        component: () => import('@/views/material/picture/EditPic'),
      },
      { //图标库
        path: '/iconrepository',
        name: 'IconRepository',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '图标库',},
        component: () => import('@/views/material/icon/IconRepository'),
      },
      { //新增图标
        path: '/uploadicon',
        name: 'UploadIcon',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '上传图标',},
        component: () => import('@/views/material/icon/UploadIcon'),
      },
      { //案例库
        path: '/examplerepository',
        name: 'ExampleRepository',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '案例库',},
        component: () => import('@/views/material/example/ExampleRepository'),
      },
      { //新建案例
        path: '/materialnewexample',
        name: 'NewExample',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '新建案例',},
        component: () => import('@/views/material/example/NewExample'),
      },
      { //编辑案例
        path: '/materialeditexample',
        name: 'EditExample',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '编辑案例', notCache: true},
        component: () => import('@/views/material/example/EditExample'),
      }, { //案例评论
        path: '/casedetail',
        name: 'casedetail',
        meta: {'hideInMenu': true, 'title': '案例评论', notCache: true},
        component: () => import('@/views/material/example/CaseDetail'),
      },
      { //电子书
        path: '/ebook',
        name: 'Ebook',
        'params': {}, 'query': {}, 'meta': {hideInMenu: true, title: '电子书',},
        component: () => import('@/views/material/ebook/EBook'),
      },
      { //电子书详情
        path: '/ebookDetail',
        name: 'EbookDetail',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '电子书详情', 'notCache': false},
        component: () => import('@/views/material/ebook/EbookDetail'),
      },
      { //编辑电子书
        path: '/editebook',
        name: 'EditEbook',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '编辑电子书', 'notCache': false},
        component: () => import('@/views/material/ebook/EditEbook'),
      },
      { //基础
        path: '/basesettings',
        name: 'basesettings',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '基础设置',},
        component: () => import('@/views/basesettings/BaseSettings'),
      },
      { //登录账户
        path: '/loginaccounts',
        name: 'LoginAccounts',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '登录账户',},
        component: () => import('@/views/basesettings/LoginAccounts'),
      },
      { //装修
        path: '/renovation',
        name: 'renovation',
        'params': {}, 'query': {}, 'meta': {'hideInMenu': true, 'title': '装修', 'notCache': false},
        component: () => import('@/views/renovation/RenovationPage.vue')
      },
    ]
  },
  { //注册
    path: '/reg',
    name: 'reg',
    component: () => import('@/views/login/reg/Register.vue'),
    meta: {
      norequirelogin: true
    }
  },
  { //登录
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login/Login.vue'),
    meta: {
      norequirelogin: true
    }
  }, {
    path: '/testlogin',
    name: 'testlogin',
    component: () => import('@/views/login/login/TestLogin.vue'),
    meta: {
      norequirelogin: true
    }
  },
  {
    path: '/personcenter',
    name: 'personcenter',
    component: () => import('@/views/basesettings/PersonCenter.vue'),
    meta: {
      norequirelogin: true
    }
  },

  {
    path: '/ebookprew',
    name: 'ebookprew',
    component: () => import('../views/material/ebook/Ebookprew'),
    meta: {
      norequirelogin: true
    }
  },
  {
    path: '*',
    name: '*',
    component: () => import('@/views/login/login/Login.vue')
  }
]
